import { hoverDynamic } from './hover';
import Navigo from 'navigo';

export function pushStateHandler() {
  // Navigo インスタンスの作成
  const router = new Navigo('/');
  
  // ページ遷移時のイベントを設定する関数
  function onPageTransition(handler) {
    return () => {
      handler();
      window.onpopstate = (e) => {
        router.resolve();
      };
    };
  }

  function drawerInit() {
    document.body.classList.remove('is-drawer-active');
    drawer.innerHTML = '';
  }

  // ルートハンドラ
  function routeHandler() {
    drawerInit();
  }

  // ドロワーハンドラ
  function drawerHandler() {
    document.body.classList.remove('is-nav-active', 'is-exhibitors-filter-active');
    document.body.classList.add('is-drawer-active');
    const hov = drawer.querySelectorAll('a, button, .js-hov');
    if(hov.length) {
      hov.forEach((el) => {
        hoverDynamic(el);
      })
    }
  }

  const currentLocation = router.getCurrentLocation();
  
  // 出展者singleページの時にハンドラを変える
  const exhibitorsSingleRegexp = new RegExp('^/exhibitors/.*$');
  let exhibitorsSingleHandler = drawerHandler;
  if (exhibitorsSingleRegexp.test(currentLocation.url)) {
    exhibitorsSingleHandler = routeHandler;
  }

  const exhibitorsEnSingleRegexp = new RegExp('^/en/exhibitors/.*$');
  let exhibitorsEnSingleHandler = drawerHandler;
  if (exhibitorsEnSingleRegexp.test(currentLocation.url)) {
    exhibitorsEnSingleHandler = routeHandler;
  }

  // フレンズsingleページの時にハンドラを変える
  const friendsSingleRegexp = new RegExp('^/friends/.*$');
  let friendsSingleHandler = drawerHandler;
  if (friendsSingleRegexp.test(currentLocation.url)) {
    friendsSingleHandler = routeHandler;
  }

  const friendsEnSingleRegexp = new RegExp('^/en/friends/.*$');
  let friendsEnSingleHandler = drawerHandler;
  if (friendsEnSingleRegexp.test(currentLocation.url)) {
    friendsEnSingleHandler = routeHandler;
  }

  // フレンズ連動企画singleページの時にハンドラを変える
  const friendsProjectsSingleRegexp = new RegExp('^/friends-projects/.*$');
  let friendsProjectsSingleHandler = drawerHandler;
  if (friendsProjectsSingleRegexp.test(currentLocation.url)) {
    friendsProjectsSingleHandler = routeHandler;
  }

  const friendsProjectsEnSingleRegexp = new RegExp('^/en/friends-projects/.*$');
  let friendsProjectsEnSingleHandler = drawerHandler;
  if (friendsProjectsEnSingleRegexp.test(currentLocation.url)) {
    friendsProjectsEnSingleHandler = routeHandler;
  }

  // Yummyエリアsingleページの時にハンドラを変える
  const yummySingleRegexp = new RegExp('^/yummy/.*$');
  let yummySingleHandler = drawerHandler;
  if (yummySingleRegexp.test(currentLocation.url)) {
    yummySingleHandler = routeHandler;
  }
  
  const yummyEnSingleRegexp = new RegExp('^/en/yummy/.*$');
  let yummyEnSingleHandler = drawerHandler;
  if (yummyEnSingleRegexp.test(currentLocation.url)) {
    yummyEnSingleHandler = routeHandler;
  }

  // ルートの定義
  router
    .on('/', onPageTransition(routeHandler))
    .on('/en/', onPageTransition(routeHandler))

    .on('/exhibitors/', onPageTransition(routeHandler))
    .on('/exhibitors/*', onPageTransition(exhibitorsSingleHandler))
    
    .on('/en/exhibitors/', onPageTransition(routeHandler))
    .on('/en/exhibitors/*', onPageTransition(exhibitorsEnSingleHandler))

    .on('/yummy/', onPageTransition(routeHandler))
    .on('/yummy/*', onPageTransition(yummySingleHandler))
    
    .on('/en/yummy/', onPageTransition(routeHandler))
    .on('/en/yummy/*', onPageTransition(yummyEnSingleHandler))

    .on('/friends/', onPageTransition(routeHandler))
    .on('/friends/*', onPageTransition(friendsSingleHandler))

    .on('/friends-projects/', onPageTransition(routeHandler))
    .on('/friends-projects/*', onPageTransition(friendsProjectsSingleHandler))

    .on('/en/friends/', onPageTransition(routeHandler))
    .on('/en/friends/*', onPageTransition(friendsEnSingleHandler))
  
    .on('/en/friends-projects/', onPageTransition(routeHandler))
    .on('/en/friends-projects/*', onPageTransition(friendsProjectsEnSingleHandler))

  const drawer = document.querySelector('.js-drawer');

  // 出展者ドロワー
  const exhibitorsPushTrigger = document.querySelectorAll('[data-exhibitors-id]');
  if(exhibitorsPushTrigger.length){
    exhibitorsPushTrigger.forEach((el) => {
      const href = el.href;
      const url = href.replace(baseURL, '');
      const exhibitorsid = el.dataset.exhibitorsId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        let currentURL = window.location.pathname;
        // 現在のURLの末尾にスラッシュがなければ追加
        if (!currentURL.endsWith('/')) currentURL += '/';
        // 現在のURLと同じの場合何もしない
        if (url == currentURL) return;

        if(exhibitorsid && exhibitorsData) {
          const foundElement = exhibitorsData.find((element) => element['id'] == exhibitorsid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const b = foundElement['booth']
            const bn = foundElement['boothnumber']
            const a = foundElement['area']
            const d = foundElement['description']
            const ui = foundElement['url_instagram']
            const ux = foundElement['url_x']
            const uf = foundElement['url_facebook']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('pt-4', 'textsize-large', 'font-bold', 'lh1_5', 'overflowwrap-breakword');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            let attr = '';
            if(b.length || bn || a.length){
              attr = document.createElement('div');
              attr.classList.add('rowm-2');
              drawer.appendChild(attr);
            }

            if(b.length){
              const container = document.createElement('div');
              container.classList.add('rowm-1', 'flex');
              const label = document.createElement('p');
              label.classList.add('font-bold', 'pr-0_5');
              if (document.documentElement.lang == 'en-US') {
                label.innerHTML = `Booth:`;
              } else {
                label.innerHTML = `ブース:`;
              }
              container.appendChild(label);
              const booth = document.createElement('div');
              booth.classList.add('flex', 'flex-slash');
              b.forEach((bb) => {
                const el = document.createElement('p');
                const title = bb['title'];
                if(title) {
                  el.innerHTML = `${title}`;
                }
                booth.appendChild(el);
              })
              container.appendChild(booth);
              if(attr) {
                attr.appendChild(container);
              }
            }

            if(bn){
              const el = document.createElement('p');
              el.classList.add('rowm-1');
              if (document.documentElement.lang == 'en-US') {
                el.innerHTML = `<b>Number:</b> ${bn}`;
              } else {
                el.innerHTML = `<b>番号:</b> ${bn}`;
              }
              attr.appendChild(el);
            }

            if(a.length){
              const container = document.createElement('div');
              container.classList.add('rowm-1', 'flex');
              const label = document.createElement('p');
              label.classList.add('font-bold', 'pr-0_5');
              if (document.documentElement.lang === "en-US") {
                label.innerHTML = `Base:`;
              } else {
                label.innerHTML = `拠点:`;
              }
              container.appendChild(label);
              const area = document.createElement('div');
              area.classList.add('flex', 'flex-slash');
              a.forEach((aa) => {
                const parent = document.createElement('div');
                parent.classList.add('flex', 'flex-hyphen');
                const title = document.createElement('p');
                title.innerHTML = `${aa['title']}`;
                const childs_arr = aa['childs'];
                if(childs_arr.length) {
                  const childs = document.createElement('div');
                  childs.classList.add('flex', 'flex-comma');
                  childs_arr.forEach((c) => {
                    const el = document.createElement('p');
                    el.innerHTML = `${c['title']}`;
                    childs.appendChild(el);
                  });
                  parent.appendChild(title);
                  parent.appendChild(childs);
                } else {
                  parent.appendChild(title);
                }
                area.appendChild(parent);
              })
              container.appendChild(area);
              if(attr) {
                attr.appendChild(container);
              }
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }

            if(ui.length){
              const dl = document.createElement('dl');
              const dt = document.createElement('dt');
              const dd = document.createElement('dd');
              const ul = document.createElement('ul');

              dl.classList.add('rowm-2');
              dd.classList.add('rowm-1');
              ul.classList.add('hover-textdecoration-underline', 'lh1_5');

              dt.innerHTML = `<b>Instagram</b>`;
              ui.forEach((u) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5', 'overflowwrap-breakword');
                const _el = document.createElement('a');
                const label = u['label'];
                const url = u['url'];
                _el.setAttribute('href', url);
                _el.setAttribute('target', '_blank');
                _el.setAttribute('rel', 'noopener');
                if(label) {
                  _el.innerHTML = `${label}`;
                } else {
                  _el.innerHTML = `${url}`;
                }
                el.appendChild(_el);
                ul.appendChild(el);
              })
              dd.appendChild(ul);
              dl.appendChild(dt);
              dl.appendChild(dd);
              drawer.appendChild(dl);
            }

            if(ux.length){
              const dl = document.createElement('dl');
              const dt = document.createElement('dt');
              const dd = document.createElement('dd');
              const ul = document.createElement('ul');

              dl.classList.add('rowm-2');
              dd.classList.add('rowm-1');
              ul.classList.add('hover-textdecoration-underline', 'lh1_5');

              dt.innerHTML = `<b>X</b>`;
              ux.forEach((u) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5', 'overflowwrap-breakword');
                const _el = document.createElement('a');
                const label = u['label'];
                const url = u['url'];
                _el.setAttribute('href', url);
                _el.setAttribute('target', '_blank');
                _el.setAttribute('rel', 'noopener');
                if(label) {
                  _el.innerHTML = `${label}`;
                } else {
                  _el.innerHTML = `${url}`;
                }
                el.appendChild(_el);
                ul.appendChild(el);
              })
              dd.appendChild(ul);
              dl.appendChild(dt);
              dl.appendChild(dd);
              drawer.appendChild(dl);
            }

            if(uf.length){
              const dl = document.createElement('dl');
              const dt = document.createElement('dt');
              const dd = document.createElement('dd');
              const ul = document.createElement('ul');

              dl.classList.add('rowm-2');
              dd.classList.add('rowm-1');
              ul.classList.add('hover-textdecoration-underline', 'lh1_5');

              dt.innerHTML = `<b>Facebook</b>`;
              uf.forEach((u) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5', 'overflowwrap-breakword');
                const _el = document.createElement('a');
                const label = u['label'];
                const url = u['url'];
                _el.setAttribute('href', url);
                _el.setAttribute('target', '_blank');
                _el.setAttribute('rel', 'noopener');
                if(label) {
                  _el.innerHTML = `${label}`;
                } else {
                  _el.innerHTML = `${url}`;
                }
                el.appendChild(_el);
                ul.appendChild(el);
              })
              dd.appendChild(ul);
              dl.appendChild(dt);
              dl.appendChild(dd);
              drawer.appendChild(dl);
            }
          }
        }

        router.navigate(url);
      })
    })
  }

  // フレンズドロワー
  const friendsPushTrigger = document.querySelectorAll('[data-friends-id]');
  if(friendsPushTrigger.length){
    friendsPushTrigger.forEach((el) => {
      const href = el.href;
      const url = href.replace(baseURL, '');
      const friendsid = el.dataset.friendsId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        let currentURL = window.location.pathname;
        // 現在のURLの末尾にスラッシュがなければ追加
        if (!currentURL.endsWith('/')) currentURL += '/';
        // 現在のURLと同じの場合何もしない
        if (url == currentURL) return;

        if(friendsid && friendsData) {
          const foundElement = friendsData.find((element) => element['id'] == friendsid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const l = foundElement['location']
            const d = foundElement['description']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('pt-4', 'textsize-large', 'font-bold', 'lh1_5');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            if(l){
              const drawerLocation = document.createElement('p');
              drawerLocation.classList.add('rowm-1_5', 'lh1_5');
              drawerLocation.innerHTML = l;
              drawer.appendChild(drawerLocation);
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }
          }
        }

        router.navigate(url);
      })
    })
  }

  // フレンズ連動企画ドロワー
  const friendsProjectsPushTrigger = document.querySelectorAll('[data-friends-projects-id]');
  if(friendsProjectsPushTrigger.length){
    friendsProjectsPushTrigger.forEach((el) => {
      const href = el.href;
      const url = href.replace(baseURL, '');
      const friendsProjectsid = el.dataset.friendsProjectsId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        let currentURL = window.location.pathname;
        // 現在のURLの末尾にスラッシュがなければ追加
        if (!currentURL.endsWith('/')) currentURL += '/';
        // 現在のURLと同じの場合何もしない
        if (url == currentURL) return;

        if(friendsProjectsid && friendsProjectsData) {
          const foundElement = friendsProjectsData.find((element) => element['id'] == friendsProjectsid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const l = foundElement['location']
            const i = foundElement['image']
            const d = foundElement['description']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('pt-4', 'textsize-large', 'font-bold', 'lh1_5');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            if(l){
              const drawerLocation = document.createElement('p');
              drawerLocation.classList.add('rowm-1_5', 'lh1_5');
              drawerLocation.innerHTML = l;
              drawer.appendChild(drawerLocation);
            }

            if(i){
              const drawerImage = document.createElement('img');
              drawerImage.classList.add('rowm-1_5');
              drawerImage.src = i;
              drawer.appendChild(drawerImage);
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }
          }
        }

        router.navigate(url);
      })
    })
  }

  // Yummyドロワー
  const yummyPushTrigger = document.querySelectorAll('[data-yummy-id]');
  if(yummyPushTrigger.length){
    yummyPushTrigger.forEach((el) => {
      const href = el.href;
      const url = href.replace(baseURL, '');
      const yummyid = el.dataset.yummyId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        let currentURL = window.location.pathname;
        // 現在のURLの末尾にスラッシュがなければ追加
        if (!currentURL.endsWith('/')) currentURL += '/';
        // 現在のURLと同じの場合何もしない
        if (url == currentURL) return;

        if(yummyid && yummyData) {
          const foundElement = yummyData.find((element) => element['id'] == yummyid);
          if(foundElement && drawer) {
            //console.log(foundElement);

            const t = foundElement['title']
            const g = foundElement['genre']
            const o = foundElement['openingday']
            const d = foundElement['description']
            const ui = foundElement['url_instagram']
            const ux = foundElement['url_x']
            const uf = foundElement['url_facebook']

            if(t){
              const drawerTitle = document.createElement('h4');
              drawerTitle.classList.add('pt-4', 'textsize-large', 'font-bold', 'lh1_5', 'overflowwrap-breakword');
              drawerTitle.innerHTML = t;
              drawer.appendChild(drawerTitle);
            }

            if(g){
              const drawerGenre = document.createElement('div');
              drawerGenre.classList.add('rowm-1');
              drawerGenre.innerHTML = g;
              if (document.documentElement.lang == 'en-US') {
                drawerGenre.innerHTML = `<b>Genre:</b> ${g}`;
              } else {
                drawerGenre.innerHTML = `<b>ジャンル:</b> ${g}`;
              }
              drawer.appendChild(drawerGenre);
            }

            if(o){
              const drawerOpeningday = document.createElement('div');
              drawerOpeningday.classList.add('rowm-1');
              if (document.documentElement.lang == 'en-US') {
                drawerOpeningdayinnerHTML = `<b>Day:</b> ${o}`;
              } else {
                drawerOpeningday.innerHTML = `<b>出店日:</b> ${o}`;
              }
              drawer.appendChild(drawerOpeningday);
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }

            if(d){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('pt-2', 'text', 'lh2');
              drawerDescription.innerHTML = d;
              drawer.appendChild(drawerDescription);
            }

            if(ui.length){
              const dl = document.createElement('dl');
              const dt = document.createElement('dt');
              const dd = document.createElement('dd');
              const ul = document.createElement('ul');

              dl.classList.add('rowm-2');
              dd.classList.add('rowm-1');
              ul.classList.add('hover-textdecoration-underline', 'lh1_5');

              dt.innerHTML = `<b>Instagram</b>`;
              ui.forEach((u) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5', 'overflowwrap-breakword');
                const _el = document.createElement('a');
                const label = u['label'];
                const url = u['url'];
                _el.setAttribute('href', url);
                _el.setAttribute('target', '_blank');
                _el.setAttribute('rel', 'noopener');
                if(label) {
                  _el.innerHTML = `${label}`;
                } else {
                  _el.innerHTML = `${url}`;
                }
                el.appendChild(_el);
                ul.appendChild(el);
              })
              dd.appendChild(ul);
              dl.appendChild(dt);
              dl.appendChild(dd);
              drawer.appendChild(dl);
            }

            if(ux.length){
              const dl = document.createElement('dl');
              const dt = document.createElement('dt');
              const dd = document.createElement('dd');
              const ul = document.createElement('ul');

              dl.classList.add('rowm-2');
              dd.classList.add('rowm-1');
              ul.classList.add('hover-textdecoration-underline', 'lh1_5');

              dt.innerHTML = `<b>X</b>`;
              ux.forEach((u) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5', 'overflowwrap-breakword');
                const _el = document.createElement('a');
                const label = u['label'];
                const url = u['url'];
                _el.setAttribute('href', url);
                _el.setAttribute('target', '_blank');
                _el.setAttribute('rel', 'noopener');
                if(label) {
                  _el.innerHTML = `${label}`;
                } else {
                  _el.innerHTML = `${url}`;
                }
                el.appendChild(_el);
                ul.appendChild(el);
              })
              dd.appendChild(ul);
              dl.appendChild(dt);
              dl.appendChild(dd);
              drawer.appendChild(dl);
            }

            if(uf.length){
              const dl = document.createElement('dl');
              const dt = document.createElement('dt');
              const dd = document.createElement('dd');
              const ul = document.createElement('ul');

              dl.classList.add('rowm-2');
              dd.classList.add('rowm-1');
              ul.classList.add('hover-textdecoration-underline', 'lh1_5');

              dt.innerHTML = `<b>Facebook</b>`;
              uf.forEach((u) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5', 'overflowwrap-breakword');
                const _el = document.createElement('a');
                const label = u['label'];
                const url = u['url'];
                _el.setAttribute('href', url);
                _el.setAttribute('target', '_blank');
                _el.setAttribute('rel', 'noopener');
                if(label) {
                  _el.innerHTML = `${label}`;
                } else {
                  _el.innerHTML = `${url}`;
                }
                el.appendChild(_el);
                ul.appendChild(el);
              })
              dd.appendChild(ul);
              dl.appendChild(dt);
              dl.appendChild(dd);
              drawer.appendChild(dl);
            }
          }
        }

        router.navigate(url);
      })
    })
  }

  const historyBackTriggers = document.querySelectorAll('.js-history-back');
  if(historyBackTriggers.length){
    historyBackTriggers.forEach((el) => {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        history.back()
      });
    })
  }
}